import React, { useEffect } from 'react';
import { validateTranslations } from '@/utils/translationValidator';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/translations';

export const useTranslation = () => {
  const { language } = useLanguage();
  
  // Validar traducciones en desarrollo
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      validateTranslations();
    }
  }, []);
  
  const t = (key: string): any => {
    const keys = key.split('.');
    let value: any = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        // Fallback to Spanish if translation is missing
        console.warn(`⚠️ Missing translation for "${key}" in language "${language}". Falling back to Spanish.`);
        value = translations.es;
        for (const fallbackKey of keys) {
          if (value && typeof value === 'object' && fallbackKey in value) {
            value = value[fallbackKey];
          } else {
            console.error(`❌ Missing translation for "${key}" in both "${language}" and Spanish fallback.`);
            return key; // Return key if no fallback found
          }
        }
        break;
      }
    }
    
    return value !== undefined ? value : key;
  };

  return { t, language };
};